import React from 'react';

const AuthLayout = function (WrapperComponent) {
  return function _InnerComponent(props) {
    return (
      <div className="bg-background h-screen w-screen flex justify-center items-center">
        <div className="bg-white border-2 p-8 w-[550px]">
          <WrapperComponent {...props} />
        </div>
      </div>
    );
  };
};

export default AuthLayout;
